var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({ref:"select",staticClass:"x-select",scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,scopedSlotName){return {key:scopedSlotName,fn:function(data){return [_vm._t(scopedSlotName,null,null,data)]}}}),_vm._l((_vm.$slots),function(_,slotName){return {key:slotName,fn:function(){return [_vm._t(slotName)]},proxy:true}})],null,true)},'v-select',{
    ..._vm.$attrs,
    ..._vm.commonAttrs
  },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }